import classNames from "classnames";
import React from "react";
import styles from "./WIIM.module.scss";

type Props = {
  headline: string;
  earlyLineBreak?: boolean;
};

const WIIM = (props: Props) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.underGraph]: props.earlyLineBreak,
      })}
    >
      <div
        className={classNames(styles.wiim, {
          [styles.centerHeader]: props.earlyLineBreak,
        })}
      >
        <h5 className={styles.header}>Why is it moving?</h5>
      </div>
      <p
        className={classNames(styles.description, {
          [styles.centerDescription]: props.earlyLineBreak,
        })}
      >
        {props.headline}
      </p>
    </div>
  );
};

export default WIIM;
